// extracted by mini-css-extract-plugin
module.exports = {"container":"AsideFooter-module__container","noteContainer":"AsideFooter-module__noteContainer"};